import React from "react";
import useApp from "../../hooks/useApp";
import { Check } from "../../assets/svgs";
import "./styles.scss";

const CheckBox = ({ onChange, containerClassName, value, label, children }) => {
  const { isRTL } = useApp();

  return (
    <div className={`check-box-container ${containerClassName}`}>
      <span
        className={`check-box ${!!value && "check-box-checked"} ${
          isRTL && "check-box-rtl"
        }`}
        onClick={onChange}
      >
        {value ? <img src={Check} alt="check" className="check-icon" /> : null}
      </span>
      <span className="check-box-label">{label ?? children}</span>
    </div>
  );
};

export default CheckBox;
